// extracted by mini-css-extract-plugin
export var actionText = "_rq-4";
export var container = "_rq-0";
export var leftSection = "_rq-1";
export var rightSection = "_rq-2";
export var settingsButton = "_rq-6";
export var settingsIcon = "_rq-7";
export var shortcut = "_rq-5";
export var shortcutGroup = "_rq-3";